import { render } from "./tablePagination.vue?vue&type=template&id=b782a45c&scoped=true"
import script from "./tablePagination.vue?vue&type=script&lang=js"
export * from "./tablePagination.vue?vue&type=script&lang=js"

import "./tablePagination.vue?vue&type=style&index=0&id=b782a45c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b782a45c"]])

export default __exports__